import { ComponentContentTypes } from '../../../lib/types/content-types'
import { TextInput } from '../../inputs/text-input'
import { SelectOption } from '../../inputs/select'
import { buildContentRenderer } from '../generic'

const contentTypeMap = {
  [ComponentContentTypes.ComponentTextInput]: TextInput,
  [ComponentContentTypes.ComponentSelect]: SelectOption,
} as const

export const FormContentRenderer = buildContentRenderer(contentTypeMap)
